"use client";

import { useContext } from "react";
import { TeamsContext } from "@/app/providers/TeamsProvider";

/**
 * Hook to access the teams context.
 * Must be used within a TeamsProvider.
 * @returns The teams context
 * @throws Error if used outside of TeamsProvider
 */
export function useTeamsContext() {
  const context = useContext(TeamsContext);
  if (!context) {
    throw new Error("useTeamsContext must be used within a TeamsProvider");
  }
  return context;
}